import React from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import EmpDir from "./pages/emp-dir";


function App() {
  return (
    <div>
      <EmpDir>
      </EmpDir>
    </div>
  );
}

export default App;
